/**
 * The entity's own right a confirm, relink or set-primary on a synced record needs besides
 * integrations.manage, keyed by sync entity type; a type not listed needs none.
 */

import { Permission } from './permission';

export const LINK_DECISION_PERMISSIONS = {
  Invoice: Permission.INVOICES_EDIT,
  Party: Permission.PARTIES_MANAGE,
  CostCenter: Permission.COST_CENTERS_MANAGE,
  Job: Permission.JOBS_MANAGE,
  OrgUnit: Permission.ORG_UNITS_MANAGE,
  OrgUnitMember: Permission.ORG_UNITS_MANAGE,
  Product: Permission.PRODUCTS_MANAGE,
  GlPosting: Permission.ACCOUNTING_CODES_MANAGE,
  VatCode: Permission.ACCOUNTING_CODES_MANAGE,
  VatPosting: Permission.ACCOUNTING_CODES_MANAGE,
  BankDocument: Permission.PAYMENTS_RECONCILE
} as const satisfies Record<string, Permission>;

/** A sync entity type whose link decisions need their own right. */
export type LinkDecisionEntityType = keyof typeof LINK_DECISION_PERMISSIONS;
